import { CreditCardCriteria } from '@nemuru-eng/js-api-client';

import { ICON_NAMES } from '@/config/config';

import { useCustomTheme } from '../../../../../../hooks/useCustomTheme';
import { SizedIconWithCircle } from '../../../../../shared/components/SizedIconWithCircle';
import { Text } from '../../../../../shared/components/Text';

export const cardTypeFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    disableOnRowClick: true,
    field: 'asset_type',
    sortable: false,
    headerName: <Text tId={'TYPE'} />,
    renderCell: (rowData: { row: CreditCardCriteria }) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={palette.grey[50]}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.chip}
          iconName={ICON_NAMES.CREDIT_CARD}
          copyToClipboard={{ value: rowData.row.id, textId: 'COPY_CREDIT_CARD_ID' }}
        />
      );
    },
  };
};
